import React, {useEffect, useState} from "react";
import { BaseUrl } from "../../../Actions/Base";
import LastLicense from "../../Institute/CourseProgress (Institute)/Components/LastLicense";
import LicenseFullView from "../../Institute/ManageNewStudent/Components/CourseInstructors/Components/LicenseFullView";
import LicenseUpdatePopup from "../../Institute/ManageNewStudent/Components/CourseInstructors/Components/LicenseUpdatePopup";
import LicenseImage from "./LicenseImage";

const AboutClient = ({ Student, StudentInfo, setActiveTab }) => {
    const studentImage = `${BaseUrl}/api/images/Student?url=${Student?.StudentImage}`;
    console.log("Student in clientinfo is:")

    const [licenseFullView, setLicenseFullView] = useState(false);
    const [licenseUpdate, setLicenseUpdate] = useState(false);
    const imageUrl = `${BaseUrl}/api/Images/LatestLicense?url=${StudentInfo?.LatestLicense}`;

    
   
    return (
        <div className="w-full flex flex-col justify-center items-center gap-[40px]">
            <div className="flex w-[90%] flex-col justify-between lg:flex-row p-[40px] rounded-[13px]"
                style={{
                    background: 'transparent linear-gradient(90deg, #FFFFFF 0%, #D6D8FF 100%) 0% 0% no-repeat padding-box'
                }}
                >
                <div className="flex flex-col items-center justify-center gap-[25px] lg:w-[45%] lg:items-start ">
                    <img
                        className="w-[200px] h-[200px] rounded-md "
                        src={studentImage}
                        alt=""
                    />
                    <InfoComp Heading="Email Address" Value={Student?.Email} />
                    <InfoComp
                        Heading="Date of Birth"
                        Value={new Date(StudentInfo?.DOB).toLocaleDateString()}
                        Src={
                            require("../Assets/BirtPlaceIcon.svg")
                                .default
                        }
                    />
                </div>
                <div className="flex w-full flex-col  justify-end gap-[25px] lg:w-[45%] mt-3 lg:mt-0">
                    <InfoComp
                        Heading="Name"
                        Value={Student?.FirstName + " " + Student?.LastName}
                    />
                    <InfoComp
                        Heading="Address"
                        Value={StudentInfo?.Address}
                    />
                    <InfoComp
                        Heading="Phone Number"
                        Value={
                            Student?.PhoneNumber
                                ? Student?.PhoneNumber
                                : "Not mentioned"
                        }
                    />
                    <InfoComp
                        Heading="Gender"
                        Value={StudentInfo?.Gender}
                    />

                <LicenseImage
                    StudentInfoId={StudentInfo?.StudentInfoId}
                    imageUrl={imageUrl}
                    setLicenseFullView={setLicenseFullView}
                    setLicenseUpdate={setLicenseUpdate}
                />
                
                </div>  
            </div>

            <div className="w-full flex justify-center">
                <button
                        onClick={()=> setActiveTab("ScheduleAndInstructor")}
                        type="button"
                        className="bg-purpal h-10 w-[100px]  hover:bg-[#7862d1] focus:ring-blue-300    rounded-lg px-5 py-[2px] text-6xs 2xl:text-5xs font-medium text-white focus:outline-none focus:ring-4"
                    >
                        Next
                </button>
            </div>

            {licenseFullView && (
            <LicenseFullView
              imageUrl={imageUrl}
              setLicenseFullView={setLicenseFullView}
            />
          )}
          {licenseUpdate && (
            <LicenseUpdatePopup setLicenseUpdate={setLicenseUpdate} />
          )}

        </div>
    );
};
const InfoComp = ({ Heading, Value, Src }) => {
    return (
        <div className="relative flex w-full max-w-[600px] flex-col gap-1">
            <h3 className="text-3xs font-normal text-[#404040] 2xl:text-2xs ">
                {Heading}{" "}
            </h3>
            <span className="flex items-center justify-between rounded-[5px] bg-white px-5 py-3 shadow-[0px_3px_6px_#00000029]">
                <h4 className="text-4xs font-normal 2xl:text-3xs">
                    {Value}
                </h4>
                {Src ? (
                    <img
                        src={Src}
                        className="absolute right-5 h-6 sm:h-[26px] md:h-7 lg:h-8"
                        alt=""
                    />
                ) : null}
            </span>
        </div>
    );
};
export default AboutClient;